module.exports = __webpack_public_path__ + "static/media/downloadApp.ed5ea90a.png";